<template>
  <div>
    <el-row :gutter="20">

      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">自动生成二维码</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate1" style="width: 100%" size="mini">绑定链接</el-button>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate3" style="width: 100%" size="mini">导出选择</el-button>
      </el-col>
      <!-- <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate4" style="width: 100%" size="mini">同步至七牛云</el-button>
      </el-col> -->
      <el-col :span="3">
        <el-select size="small" v-model="batch_notes" filterable placeholder="请选择批次" remote clearable  @change="handleLinkChange4">
          <el-option
                  v-for="item in groupList"
                  :key="item.key"
                  :label="item.batch_notes"
                  :value="item.batch_notes"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="exploadCode" style="width: 100%" size="mini">二维码下载</el-button>
      </el-col>


    </el-row>
    <el-row :gutter="100">
    <el-col :span="100" type="info" class="grid-content bg-purple" style="margin:0 2rem;">
      <h4  style="color:orange; margin-top: 1rem;"type="warning">警告：访问此页面请使用http协议。或<el-link style="margin-left:1rem; font-weight:800;" href="http://b.yaoking.cn/publicity/publicity_qrcodes" type="success">点击此处</el-link></h4>
      <h4 style="margin-bottom: 1rem;" type="info">注：宣传码生成规则为：https://r.yaoking.cn/?codes=标识符（例如：https://r.yaoking.cn/?codes=100000000001）</h4>
    </el-col>
    </el-row>
   <el-table :data="data" :height="wheight-130" v-loading="loading"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" label="全选" v-if="batch_notes==''"></el-table-column>
      <el-table-column prop="id" label="ID" width="60"></el-table-column>
      <el-table-column prop="codes" label="标识符" width="120"></el-table-column>
      <el-table-column prop="link_title" label="链接标题" width="180"></el-table-column>

      <el-table-column prop="user_id" label="员工id" width="80"></el-table-column>
      <el-table-column prop="activation" label="激活状态" width="100">
        <template slot-scope="scope">
            <el-tag size="mini" effect="plain" type="success" v-if="scope.row.activation=='1'">已激活</el-tag>
            <el-tag size="mini" effect="plain" v-else>未激活</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="operator_id" label="操作员ID" width="80"></el-table-column>
      <el-table-column prop="operator_name" label="操作员姓名" width="100"></el-table-column>
      <el-table-column prop="activated_at" label="激活时间" width="160">
          <template slot-scope="scope">{{scope.row.activated_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="counts" label="扫码次数" width="100"></el-table-column>
       <el-table-column prop="created_at" label="数据生成时间" width="160">
          <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="updated_at" label="数据更新时间" width="160">
          <template slot-scope="scope">{{scope.row.updated_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column prop="updated_at" label="查看二维码" width="100">
          <template slot-scope="scope"><el-link type="primary" @click="exploadCodeOne(scope.row)">查看二维码</el-link></template>

      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <!-- <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

   <div v-if="total_count > params.pageSize" class="content-padded content-center">
       <el-pagination
               background
               layout="prev, pager, next"
               @current-change="handleCurrentChange"
               :current-page.sync="params.page"
               :total="total_count" :page-size="params.pageSize">
       </el-pagination>
   </div>
    <el-dialog title="选择生成数量" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog" v-loading="loading1">
      <template>
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
          <el-form-item class="content-left" label="生成数量:" prop="content_type" :rules="[{ required: true, message: '请选择', trigger: 'blur' }]">
            <el-select v-model="form.num" placeholder="请选择">
              <el-option
                v-for="(item, index) in nums"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item class="content-left" label="批次备注:" prop="content_type" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input type="text"  placeholder="批次备注"  v-model="form.remarks"  size="small"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="随机标识符">
              <el-radio-group v-model="form.randflag" size="small">
                  <el-radio label="1" border>随机标识符（一次性适用）</el-radio>
                  <el-radio label="0" border>顺序标识符</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item class="content-left">
            <el-button type="primary" @click="saveData">确定生成</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
    <el-dialog title="编辑/修改(单行)" width="30%" :visible.sync="memberTagDialog2" :before-close="handleCancelLabelsDialog2">
      <template>
        <el-form ref="form" :model="saveForm" class="demo-ruleForm" label-width="230px">
          <el-form-item class="content-left" label="修改前链接" prop="content_type" :rules="[{ required: true, message: '请选择', trigger: 'blur' }]">
              <span>{{saveForm.link_title}}</span>
          </el-form-item>
          <el-form-item class="content-left" label="绑定链接" prop="content_type" :rules="[{ required: true, message: '请选择', trigger: 'blur' }]">
           <el-select size="small" v-model="saveForm.link_id" filterable placeholder="请选择连接" remote :remote-method="getLinkList" @change="handleLinkChange1">
               <el-option
                       v-for="item in linksList"
                       :key="item.id"
                       :label="item.content"
                       :value="item.id"
               >
               </el-option>
           </el-select>
          </el-form-item>

          <el-form-item class="content-left">
            <el-button type="primary" @click="saveRow">确定修改</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
    <el-dialog title="导出选择" width="30%" :visible.sync="memberTagDialog3" :before-close="handleCancelLabelsDialog3">
     <template>
       <el-form ref="form" :model="exp" class="demo-ruleForm" label-width="100px">

        <el-form-item class="content-left" label="方式选择">
           <el-radio-group v-model="exp.mode_type" size="small">
            <el-radio label="1" border>标识符区间</el-radio>
            <!-- <el-radio label="2" border>类型</el-radio> -->
            <el-radio label="3" border>标题</el-radio>
           </el-radio-group>
        </el-form-item>
        <el-form-item class="content-left" label="区间:" v-if="exp.mode_type==1">
          <el-input type="text"  placeholder="起始"  v-model="exp.start"  size="small" class="num_b"></el-input>-
          <el-input type="text"  placeholder="结束"  v-model="exp.end"  size="small" class="num_b"></el-input>
        </el-form-item>
        <!-- <el-form-item  v-if="exp.mode_type==1" class="content-left" label="标识符区间">
            <el-slider
                  v-model="exp.value"
                  range
                  :step="100"
                  show-stops
                  show-tooltip

                  :min="100000000001"
                  :max="maxCodes">
                </el-slider>
        </el-form-item> -->
       <!-- <el-form-item  v-if="exp.mode_type==2" class="content-left" label="类型选择">
            <el-select size="small" v-model="exp.type" clearable placeholder="链接类型">
                <el-option v-for="item in content_types" :key="item.value" :label="item.name" size="mini" :value="item.value"> </el-option>
            </el-select>
        </el-form-item> -->
        <el-form-item  v-if="exp.mode_type==3" class="content-left" label="绑定链接" prop="content_type" :rules="[{ required: true, message: '请选择', trigger: 'blur' }]">
         <el-select size="small" v-model="exp.link_id" filterable placeholder="请选择连接" remote :remote-method="getLinkList" @change="handleLinkChange3">
             <el-option
                     v-for="item in linksList"
                     :key="item.id"
                     :label="item.content"
                     :value="item.id"
             >
             </el-option>
         </el-select>
         </el-form-item>
         <el-form-item class="content-center">
           <el-button type="primary" @click="expData">确定导出</el-button>
         </el-form-item>
       </el-form>
     </template>
    </el-dialog>
    <el-dialog title="同步七牛云" width="30%" :visible.sync="memberTagDialog4" :before-close="handleCancelLabelsDialog4">
     <template>
       <el-form ref="form" :model="SynchroRow" class="demo-ruleForm" label-width="100px">

        <el-form-item  class="content-left" label="绑定链接" prop="content_type" :rules="[{ required: true, message: '请选择', trigger: 'blur' }]">
         <el-select size="small" v-model="SynchroRow.batch_notes" filterable placeholder="请选择批次" remote  @change="handleLinkChange4">
             <el-option
                     v-for="item in groupList"
                     :key="item.key"
                     :label="item.batch_notes"
                     :value="item.batch_notes"
             >
             </el-option>
         </el-select>
         </el-form-item>
         <el-form-item class="content-center">
           <el-button type="primary" @click="Synchro">确定</el-button>
         </el-form-item>
       </el-form>
     </template>
    </el-dialog>
    <el-dialog title="绑定二维码" width="40%" :visible.sync="memberTagDialog1" :before-close="handleCancelLabelsDialog1">
      <template>
        <el-form ref="form" :model="bang" class="demo-ruleForm" label-width="230px">
          <el-form-item class="content-left" label="绑定数量:">
            <el-input type="text"  placeholder="绑定数量"  v-model="bang.num_b"  size="small" class="num_b"></el-input>
          </el-form-item>
          <el-form-item class="content-left" label="绑定类型">
            <el-radio-group v-model="content_type" size="small" @change="changeContentType">
              <el-radio label="商品" border>商品</el-radio>
              <el-radio label="专题" border>专题</el-radio>
              <el-radio label="品牌" border>品牌</el-radio>
              <el-radio label="充余额" border>充余额</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="content_type=='商品'" class="content-left" label="是否小程序">
            <el-radio-group v-model="is_wxapp" size="small">
                <el-radio label="1" border>是</el-radio>
                <el-radio label="0" border>否</el-radio>
              </el-radio-group>
          </el-form-item>

          <el-form-item v-if="content_type=='商品'" class="content-left" label="选择商品">
               <el-select v-model="relItemsShops" filterable placeholder="请输入商品货号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange"  style="width: 55%;">
                   <el-option
                           v-for="item in relItemsShopsList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"
                   >
                   </el-option>
               </el-select>
               <div v-show="false">
                   <el-col>
                       <el-input v-model="relItemsShopsVal"></el-input>
                   </el-col>
               </div>
          </el-form-item>
          <!-- <el-form-item v-if="content_type =='商品' && is_wxapp=='1'" class="content-left" label="小程序中转链接(非必填)">
            <el-input type="text"  placeholder="小程序中转链接"  v-model="transit_links"  size="small"></el-input>
          </el-form-item> -->
          <el-form-item v-else class="content-left" label="绑定链接">
            <el-select size="small" v-model="bang.link_id" filterable placeholder="请选择连接" remote :remote-method="getLinkList" @change="handleLinkChange">
                <el-option
                        v-for="item in linksList"
                        :key="item.id"
                        :label="item.content"
                        :value="item.id"
                >
                </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="content-left">
            <el-button type="primary" @click="upData">确定绑定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>
  </div>

</template>
<script>

  import axios from 'axios'
  import JSZip from 'jszip'
  // eslint-disable-next-line no-unused-vars
  import FileSaver from 'file-saver'
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import {getShopItemsDetailAll} from '@/api/live'
  import { getQrcodes,addQrcodes,getPublicity,updateQrcodes,updateOneData,expDataApi,addPublicity,qrcodeDownload,qrcodeSynchro} from '@/api/publicity'
  export default {
    data () {
      return {
        data: [],
        batch_notes:"",
        upload_at:'',
        loading: false,
        loading1: false,
        is_wxapp: "1",
        content_type:'专题',
        linksList:[],
        transit_links:'',
        multipleSelection:[],
        nums:[
              { value: '50', name: "50" },
              { value: '100', name: "100" },
              { value: '200', name: "200" },
              { value: '500', name: "500" },
              { value: '800', name: "800" },
              { value: '1000', name: "1000" },
              { value: '2000', name: '2000' },
              { value: '5000', name: '5000' },
              { value: '10000', name: '10000' },
          ],
        nums_b:[
              { value: '10', name: "10" },
              { value: '20', name: '20' },
              { value: '50', name: '50' },
              { value: '100', name: '100' },
          ],
        links_types:[
              { name: 'h5', value: 'h5' },
              { name: 'custom', value: 'custom' },
              { name: 'wxapp', value: 'wxapp' },
          ],
        content_types:[
              { value: '商品', name: "商品" },
              { value: '专题', name: '专题' },
              { value: '品牌', name: '品牌' },
          ],
        memberTagDialog: false,
        memberTagDialog1: false,
        memberTagDialog2: false,
        memberTagDialog3:false,
        memberTagDialog4:false,
        total_count: 0,
        relItemsShopsVal:"",
        relItemsShopsList:[],
        relItemsShops:"",
        relItems: [],
        maxCodes:100000000000,
        params: {
          page: 1,
          pageSize: 20,
        },
        bang:{},
        form: {
          num: '',
        },
        groupList:[],
        saveForm:{},
        addFrom:{},
        exp:{},
        SynchroRow:{},
        params_link:{},
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange () {
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
      },
      addTemplate1 () { // 绑定链接
        this.memberTagDialog1 = true
      },
      addTemplate3 () { // 导出选择
        this.memberTagDialog3 = true
      },
      addTemplate4 () { // 导出选择
        this.memberTagDialog4 = true
      },
      handleSelectionChange(val) {
        if(this.batch_notes!=""){

            this.$message({
              message: '您已选中批次复选框失效',
              type: 'error',
              duration: 5 * 1000
            })
            this.multipleSelection=[];
            return
        }
        this.multipleSelection=[];
        val.forEach((item, index) => {
          this.multipleSelection.push(item.codes)
        })
      },
      exploadCode(){ //选择导出
        const zip = new JSZip()
        const cache = {}
        const promises = []

        if(this.multipleSelection.length>0 || this.batch_notes!=""){

          let params = {};
          params.codes=this.multipleSelection
          params.batch_notes=this.batch_notes

          qrcodeDownload(params).then(res=>{

            const zip = new JSZip()
            const cache = {}
            const promises = []
            res.data.data.forEach(item => {
              const promise = this.getFile(item.url).then(data => {
                const file_name = item.name
                zip.file(file_name, data, { binary: true })
                cache[file_name] = data
              })
              promises.push(promise)
            })
            Promise.all(promises).then(() => {
              zip.generateAsync({ type: 'blob' }).then(content => {
                // 生成二进制流
                // FileSaver.saveAs(content, '文件下载.zip') // 利用file-saver保存文件  自定义文件名
                saveAs(content, '宣传码.zip') // 利用file-saver保存文件  自定义文件名
              })
            })
            // this.downloadIamges(item.url,item.name)
        })
        }else{
            this.$message({
              message: '至少选择一个二维码或者一个批次',
              type: 'error',
              duration: 5 * 1000
            })
        }
      },

      changeContentType(val){
          this.params_link.content_type = val;
          this.getLinkList()
      },
      getFile (url) {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url,
            responseType: 'blob'
            // responseType: 'arraybuffer'
          })
            .then(data => {
              console.log('data', data)
              resolve(data.data)
            })
            .catch(error => {
              reject(error.toString())
            })
        })
      },
      downloadIamges(imgsrc, name) {
      	    //下载图片地址和图片名
      	    var image = new Image();
      	    // 解决跨域 Canvas 污染问题
      	    image.setAttribute('crossOrigin', 'anonymous');
      	    image.onload = function () {
      	        var canvas = document.createElement('canvas');
      	        canvas.width = image.width;
      	        canvas.height = image.height;
      	        var context = canvas.getContext('2d');
      	        context.drawImage(image, 0, 0, image.width, image.height);
      	        var _dataURL = canvas.toDataURL('image/png'); //得到图片的base64编码数据

      	        var blob_ = dataURLtoBlob(_dataURL); // 用到Blob是因为图片文件过大时，在一部风浏览器上会下载失败，而Blob就不会

      	        var url = {
      	            name: name || "图片.png", // 图片名称不需要加.png后缀名
      	            src: blob_
      	        };

      	        if (window.navigator.msSaveOrOpenBlob) {   // if browser is IE
      	            navigator.msSaveBlob(url.src, url.name);//filename文件名包括扩展名，下载路径为浏览器默认路径
      	        } else {
      	            var link = document.createElement("a");
      	            link.setAttribute("href", window.URL.createObjectURL(url.src));
      	            link.setAttribute("download", url.name + '.png');
      	            document.body.appendChild(link);
      	            link.click();
      	        }
      	    };
      	    image.src = imgsrc;

      	    function dataURLtoBlob(dataurl) {
      	        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      	            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      	        while (n--) {
      	            u8arr[n] = bstr.charCodeAt(n);
      	        }
      	        return new Blob([u8arr], {type: mime});
      	    }
      	},
      exploadCodeOne(row){
          let arr = [];
          arr.push(row.codes)
          qrcodeDownload({"codes":arr}).then(res=>{
              this.downloadIamge(res.data.data[0].url,res.data.data[0].name)
          })
        },
       downloadIamge(imgsrc, name) {//下载图片地址和图片名
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
          let a = document.createElement("a"); // 生成一个a元素
          let event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      },
      Synchro(){
        qrcodeSynchro(this.SynchroRow).then(response => {
            this.$message({
              message: '成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.memberTagDialog4 = false
            this.getDataList()
          })
      },
      //   选择商品
      getItemShopsList(val){
          getShopItemsDetailAll({page: 1, pageSize: 50,id:val}).then(res => {
              this.relItemsShopsList = [];
              for (let item of res.data.data.list) {
                  this.relItemsShopsList.push({name: item.item_name, id: item.item_id, item_bn:item.item_bn})
              }
              // this.relItemsShopsList = openitems.slice(0,1)
              this.addFrom.links = "https://h5.yaoking.cn/pages/search/ybindex-search-result?bn="+this.relItemsShopsList[0].item_bn
              this.addFrom.content = this.relItemsShopsList[0].name
              this.addFrom.content_type = "商品"
              if(this.is_wxapp==1){
                this.addFrom.links_type = "wxapp"
                this.addFrom.transit_links = "pages/home/searchRes/goods?search_type=goods"
              }else{
                this.addFrom.links_type = "h5"
              }
              console.log(this.addFrom)
              addPublicity(this.addFrom).then(res => {
                this.bang.link_id = res.data.data.id
              })
          })
      },
      handleItemShopsChange:function (val){
            this.form.shopsItem = val
      },
      expData(){
        // this.$router.push('./qrcodelist',{data:123})
        // return
        expDataApi(this.exp).then(response => {
            this.memberTagDialog3 = false
            window.open('http://ddps.yaoking.cn/wechatAuth/qrcode/qrlist.html')
            this.getDataList()
          })
      },
      openWin(html){
        window.open('','','').document.write(html)
        // window.open('','','').focus();
      },
      editAction (index, row) { // 编辑商品弹框
        this.saveForm = row
        // if(this.saveForm.publicity_links_id==null){
        //   this.$message({
        //     message: '无绑定，勿修改',
        //     type: 'error',
        //     duration: 5 * 1000
        //   })
        this.memberTagDialog2 = true
        // }else{
        //   this.memberTagDialog2 = true
        // }

      },
      saveRow(){  //单行修改
        updateOneData(this.saveForm).then(response => {
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.memberTagDialog2 = false
            this.getDataList()
          })
      },
      deleteAction (index, row) {

        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deletePublicity(row.id).then(response => {
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      //   绑定链接
      handleCancelLabelsDialog1 () {
        this.memberTagDialog1 = false
      },
      //   单行修改
      handleCancelLabelsDialog2 () {
        this.memberTagDialog2 = false
      },
      //   单行修改
      handleCancelLabelsDialog3 () {
        this.memberTagDialog3 = false
      },
      handleCancelLabelsDialog4 () {
        this.memberTagDialog4 = false
      },
      handleLinkChange(val){
          console.log(this.bang)

      },
      handleLinkChange1(val){
          console.log(this.saveForm)
      },
      handleLinkChange3(val){
          console.log(this.saveForm)
      },
      handleLinkChange4(val){
          if(this.multipleSelection.length>0){
            this.batch_notes=""
            this.$message({
              type: 'error',
              message: '您已多选。不能选择批次'
            })
          }
          this.params.batch_notes=this.batch_notes
          this.getDataList();
          console.log(this.SynchroRow)
      },
      getLinkList(val){
        this.params_link;
        getPublicity(this.params_link).then(response => {
          this.linksList = response.data.data.list;
        })
      },
      getDataList () {
        this.loading = true
        getQrcodes(this.params).then(response => {
          this.data = response.data.data.list
          this.total_count = response.data.data.total_count
          this.groupList = response.data.data.batch
          this.loading = false
        })
      },

      saveData () {
        this.loading1 = true
        addQrcodes(this.form).then(res => {
            this.memberTagDialog = false
            this.loading1 = false
          // if (res.data.data) {
          //   this.$message({
          //     type: 'success',
          //     message: '生成成功'
          //   })


          // }
          this.getDataList()
        })
      },
      upData(){

        updateQrcodes(this.bang).then(res => {
          if (res.data.data) {
            this.$message({
              type: 'success',
              message: '绑定链接成功'
            })
            this.memberTagDialog1 = false
            this.getDataList()
          }
        })
      },
      updateDateChange (val) {
          if (val && val.length > 0) {
              this.params.start_upload_at = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
              this.params.end_upload_at = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          } else {
              this.params.start_upload_at = ''
              this.params.end_upload_at = ''
          }
          this.getDataList();
      },
      dateStrToTimeStamp (str) {
          return Date.parse(new Date(str))/1000
      }
    },
    mounted () {
      this.getDataList();
      this.getLinkList();
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
  .num_b{
    width: 130px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// publicity_qrcodes.vue?6604fa9e